import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { getCusOnboarded } from "http/UAM/userDashboardWidget.helper";
import NoDataChart from "pages/EntityMoreInformation/NoDataComponent";

const CusOnboarded = () => {
  const [customerData, setCustomerData] = useState([]);
  const [showStatus, setShowStatus] = useState(true)

  useEffect(() => {
    getCusOnboarded().then((res) => {
      if (res.status) {
        setCustomerData(res.data);
        const allDealCountsAreZero =res.data.some(item => item.customerCount != '0');
        setShowStatus(allDealCountsAreZero)
      }
    });
  }, []);

  const options = {
    chart: {
      type: "line",
      height: 500,
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2
      },
      zoom: {
        enabled: false,
      }
    },
    xaxis: {
      categories: customerData.map((data) => data.monthYear),
    },
    yaxis: {
      title: {
        text: 'Customers Onboarded'
      }
    },
    colors: ["#34c38f"],
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    markers: {
      size: 8,
      colors: "#34c38f",
      strokeColors: '#fff',
      strokeWidth: 3,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " customers";
        },
      },
    },
  };

  return (
    <Card>
      {showStatus ? <CardBody>
        <h4 className="card-title mb-2">
          Customers Onboarded
        </h4>
        <div style={{ maxWidth: "100%" }}>
          <ReactApexChart
            options={options}
            series={[{ name: "", data: customerData.map((data) => parseInt(data.customerCount)) }]}
            type="line"
            height={325}
          />
        </div>
      </CardBody>
        : <NoDataChart title='No Information Found' subtitle="No Customer has Onboarded" />}
    </Card>
  );
};

export default CusOnboarded;
